module.exports = __webpack_public_path__ + "img/cloth_g1_shirt_02.89dc6a65.svg";